import { insuranceMonitorsApi } from "@api";

import { useWSMutation } from "../../../../../query/helpers";
import {
  downloadFileFromBlob,
  mimeTypeToExtension
} from "../../../../../utils/files";
import { WSServiceError } from "../../../../../utils/serviceHelper";

/**
 * Downloads the certificate of insurance behind a monitor's linked coverage.
 *
 * `getInsuranceMonitorCertificate` streams the stored file with its own
 * `Content-Type`, so the extension is derived from the blob rather than
 * assumed. Payer-only, matching the v1 endpoint it replaces.
 *
 * The server answers 404 whenever there is nothing to hand back — including
 * when the linked coverage came from a Wingspan plan enrollment rather than an
 * upload — so callers gate the action on the coverage's source type.
 */
export const useMutationDownloadInsuranceCertificate = () =>
  useWSMutation<void, WSServiceError, { monitorId: string; fileName: string }>(
    async ({ monitorId, fileName }) => {
      const blob = await insuranceMonitorsApi.getInsuranceMonitorCertificate({
        monitorId
      });

      downloadFileFromBlob(
        blob,
        `${fileName}.${mimeTypeToExtension(blob.type)}`
      );
    }
  );
